<template>
  <v-container>
    <v-layout wrap>
      <v-flex mb-4 md8 offset-md2>
        <h1
          class="display-2 font-weight-bold mb-3 primary--text text-xs-center"
        >
          ClicknCom's email signature
        </h1>
        <p class="subheading font-weight-regular">
          Enter your information in the form below, it will generate the html of
          your signature.
          <strong
            >Import the generated HTML file in your email client's signature
            settings.</strong
          >, to do that in Outlook, save the generated HTML file in
          <i>C:\Users\[username]\AppData\Roaming\Microsoft\Signatures</i>, it
          will appear in your signatures files in Outlook
        </p>
        <p class="subheading font-weight-regular">
          Your firstname and lastname will be uppercase in your signature.
          Please note that the typecase you enter will be respected in the link
          on the email address which will be used in the mail client of the
          people using this link to send you emails. White characters in your
          phone number are up to you.
        </p>
      </v-flex>

      <v-flex mb-5 xs12 md8 offset-md2>
        <form>
          <v-container>
            <v-layout row>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="firstname"
                  label="Firstname"
                  required
                  class="mr-2"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="lastname"
                  label="Lastname"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="role"
                  label="Role"
                  required
                  class="mr-2"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="email"
                  label="Email"
                  required
                  class="mr-2"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="phone"
                  label="Phone"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-flex>
      <v-flex mb-5 xs12 md8 offset-md2>
        <div v-html="html" class="sign-cont"></div>
      </v-flex>
      <v-flex mb-5 xs12 md8 offset-md2 text-xs-center>
        <v-alert :value="copied" type="success">
          HTML of your signature has been copied !
        </v-alert>
        <v-btn @click="copy" class="primary">Copy code</v-btn>
        <v-btn @click="download" class="primary">Download HTML</v-btn>
        <v-textarea
          id="htemail"
          name="input-7-1"
          :label="
            'HTML to paste in your mail client (' +
              (htmlmin.length / 1024).toFixed(2) +
              'ko)'
          "
          :value="htmlmin"
          ref="textarea"
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    firstname: "Nana",
    lastname: "Mouskouri",
    role: "CSO",
    email: "nana.m@clickncom.com",
    phone: "+33 123 456 879",
    copied: false
  }),
  mounted() {
    if (localStorage.firstname) this.firstname = localStorage.firstname;
    if (localStorage.lastname) this.lastname = localStorage.lastname;
    if (localStorage.role) this.role = localStorage.role;
    if (localStorage.email) this.email = localStorage.email;
    if (localStorage.phone) this.phone = localStorage.phone;
  },
  watch: {
    firstname(n) {
      localStorage.firstname = n;
    },
    lastname(n) {
      localStorage.lastname = n;
    },
    role(n) {
      localStorage.role = n;
    },
    email(n) {
      localStorage.email = n;
    },
    phone(n) {
      localStorage.phone = n;
    }
  },
  computed: {
    html() {
      return `
        <table bgcolor="#0bccb6" style="background-color: #0bccb6;color: white; font-family: 'Roboto', sans-serif; font-size: 12px; text-align:left;width:600px" border="0" cellspacing="0" cellpadding="0" width="600" >
          <tr>
            <td style="text-align:center; background-color:#0bccb6;padding:0px" width="160" border="0" cellspacing="0" cellpadding="0" bgcolor="#0bccb6">
              <a href="https://www.clickncom.com" target="_blank" style="color: white; text-decoration: none;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA4CAMAAAA8cK3qAAAAzFBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9jif6XAAAAQ3RSTlMABQkjaZ2AYQsyWf3cueYV2Sn1TAMRLc/BPO2oGXkOU4119wFs38XJ+UTNZOqYtJFAq69wcnxH8dZdh73THTeU5KWiyv4eEQAABAxJREFUGBntwOdS6ggAhuE3QEhCDSX0KiAdBcSGiPrd/z0tSQSPfxFndmfPw1//dffzYe2xHovwe5yKQpkEv6WtL3t+R04Hbie2qehgza+4lrTH19aBx+X1opLSBHpTSU1+QVNSg09lacIv+JAmHMWlqwiXt5TSHPUlRbgkG58puRxlJ6MNgSI/592lBw+DRd8gJqnKSQNorVduxl30I/zIuqbQoIqkWZE/PM0UerP4gbm+OE+SVnzp6MuGs/V1sIy1uxVJaV4kTTmK6SDdT6zTOrjnTBEdPOHrJmsFdklJUUKRpCQLX1PSW5Hz9CXFCDVaGO9JSRlCMUl9Qh1JBudJSy5fygq8E0hLLkfPizFnqkl3nCwlPbqSEvhcqcMFjKQER21JAzwdZAFS0oYLeJRMjspSsgFxSWWAa6nOkedwrr0kj1BO0jPAQtIcWEmjFqFoTWaP8ziShgQirqQcvpmkAqwkXRMwUpKKnGkh6aWd7TWsgaQHA58jKemx1EE54eG1U5JMzhXJ6+DqbSRfrUggLqnCXIGHVF4HNYOzlQb6w45QWVK3rj+kopyvZ8Qz8r10JPUJ2Q8KxGMz+QbNIj8Tue9vYlUYSDM+VRVoYI/7m/64x6VYkio9QpYO5lxeWdIkSqCpgycuL5uXlPyIFRKdgQIOl5d703czj8trzXW0dZ4llfgN0U06VXsb7m+BVWZf5H/OaJaA/ivfle64oJbuAL3z3Z24IFsWcB/lOyvPj0VuXh4/ogC2LOA+h+827U7u8Fl5YGc2IGFFK+62Sqiddod9QtGV+xLHF5mOl27llVLFXUT5FE0+1M2M2oAtC9Ac4FkTc6FrACsP5K9sWGpWMSe6x3ejiZnWNb6CXLOuxyLQkspmWev80HS1I2Ak0wBNVcGWBWTiQFcFwNPQACsP7wKIawrM1QKacoCsroGS4oCRfwQMrYAPdYBUmUBcBMYlsGUBmTgYauKzEwZYeWLKAZjCpykYauJrJXrwksG3UwG85C2QUxRIiEB5wYktC8jEwVGWk+nkVQV89Ro+bcBRlhNtCIxM8K5ugahKQPuKwHDLiS0LyMQhpx0n7cyV1vjqM3zqQk47TtQhkNyDNxoDOTlAIk9gLQIFB2xZQCYO6AafZxlQ1aqgBEB9BtBTF9ANvqzVg8oIn6MqeKMxkJMDJPKEMqkWsNcr2JoCsziQUBfIqWJAQgZrOcDyAaCnLvCkJ6CkLbBTHYgqDXjJeyAnB0iMCNkv+evtLF8FWuoD6gBMk6ntMFkHWAuoy4G0AHqKA8SU2pb1jq/0kNleJ5cAWRWAkl4BSxwV9uYUX3HcAKpRfHbX7Lzia9wCtB0oVfGNdwC9bNd8dvgUM/dVfMatB9jjFpC95a9/o38A/8O+XtsuRAgAAAAASUVORK5CYII=" alt="ClicknCom" /></a>
            </td>
            <td bgcolor="#061a34" style="background-color: #061a34;color: white; font-size: 14px; line-height: 1;padding: 15px;" border="0" cellspacing="0" cellpadding="15">
              <table border="0" cellspacing="0" cellpadding="0">
                <tr><td><span style="color: white;">${this.firstname.toUpperCase()}&nbsp;<b>${this.lastname.toUpperCase()}</b></span></td></tr>
                <tr><td style="padding-bottom: 10px"><span style="color: #0bccb6; font-weight: bold; text-decoration:underline">${
                  this.role
                }</span></td></tr>
              <tr>
              <td style="vertical-align:middle;" valign="middle" border="0" cellspacing="0" cellpadding="0"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAArklEQVQ4jc2QMQrCQBBFX5YgwoKnWQykTqHb5UTBMwWGQGxjEeYiHmAxpYWLGElQYhF/NbD/PXYG1k5iVa7AdiE/pMDuB8HGACXQL4B7oEwArArAATgB+y/ACmiC8xirUgN5cL4BMuA486M+vmWxm1uV2gAF0FmVdkY0BbZABxSJVbkxPuIZqILzl7gawXmsSh5XLF66w5RgJIrzO/gUpLOnegBT0CjmU+H/BevnDrYoOE/yO05mAAAAAElFTkSuQmCC" width="12" height="12" style="vertical-align:middle;width:12px;height:12px;" valign="middle"/>&nbsp;<a href='mailto:"${
                this.firstname
              }%20${this.lastname}"<${
        this.email
      }>' style="color: white; text-decoration:none;vertical-align:middle;" valign="middle">${
        this.email
      }</a></td></tr>
            <tr>
              <td style="vertical-align:middle;" valign="middle" border="0" cellspacing="0" cellpadding="0"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAvUlEQVQ4jeWSMQoCMRREn7KFEBEPIZ5g0dI+CB7CGwhWoha2Vl7EbrHYyjp2YqEXELRdsJDFJsI3m6wKdk4TZpJ5+cWvIKRMMgPGQCTinFcts1jPnyZyLrtAnXJ1pHEBAFtgEShP3MAHOGexTn1tZZIh0JRZNfDTx3IBXwN/PsE/Anx70FAmaQXeF7bUBeSABk7W3+xZE2827wBSPeAO7AITFQAHoC/8wAPdlwGmwMUW28DI5lfgCKyBlSw8AE1pHsf1CXSCAAAAAElFTkSuQmCC" width="12" height="12" style="vertical-align:middle;width:12px;height:12px;" valign="middle" />&nbsp;<a href="tel:${this.phone.replace(
                / /g,
                ""
              )}" style="color: white; text-decoration:none;vertical-align:middle;" valign="middle" >${
        this.phone
      }</a></td></tr></table>
            </td>
            <td bgcolor="#061a34" style="background-color: #061a34;padding:15px; vertical-align:bottom; text-align:right; font-size:14px;" valign="bottom" align="right" border="0" cellspacing="0" cellpadding="15">
              <a href="https://www.clickncom.com" target="_blank" style="color: #0bccb6; text-decoration: none;">www.clickncom.com</a>
            </td>
            </tr>
            </table>
      `;
    },
    htmlmin() {
      return this.html.replace(/>\s+|\s+</g, function(m) {
        return m.trim();
      });
    }
  },
  methods: {
    copy() {
      var copyText = document.getElementById("htemail");
      copyText.select();
      document.execCommand("copy");
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 3000);
    },
    download() {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/html;charset=utf-8," +
          encodeURIComponent(
            "<!DOCTYPE html><html><body><p></p>" +
              this.htmlmin +
              "</body></html>"
          )
      );
      element.setAttribute(
        "download",
        "clickncom-" +
          this.firstname.toLowerCase() +
          "-" +
          this.lastname.toLowerCase() +
          "-signature.html"
      );

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  }
};
</script>

<style>
.sign-cont > table {
  margin: auto;
}
</style>
